$(function() {
    $("#device_id").css("display");

    $(document).on("click", "#close_slideup", function(){
        Cookies.set('slideup_fotboll_ad_closed', 1, { expires: 1, path: '/', secure: true });
        $(".slideup_wrapper").fadeOut();
        $(".slideup_wrapper").remove();
        $('body').removeClass('slideup-visible');
        return false;
    });

    if($(".slideup_wrapper").length > 0){
        setTimeout(function(){
            $('.slideup_wrapper').fadeIn(500);
            $('body').addClass('slideup-visible');
        }, 10000);
    }

    $(".content-holder").each(function(i){
        var device = $("#device_id").css("display");
        if(device == "block"){
            device = "small";
        } else {
            device = "large";
        }
        var ad_size = $(this).data("size");
        if(ad_size != device){
            if(ad_size != "both"){
                return;
            }
        }
        var sticky = $(this).data("sticky");
        if(sticky){
            var cssClass = "sticky";
        } else {
            var cssClass = "";
        }
        var ip = $("#device_id").val();
        var input_el = $(this);
        var ad_id = $(this).data("content-id");
        var exclude_label = $(this).data("exclude-label");
        var internal = $(this).data("internal");
        //return false;
        $.get(
            ajaxUrl+"/ajax/getAdById.php",
            {
                ad_id : ad_id,
                exclude_label : exclude_label,
                internal : internal,
                device : device,
                ip : ip
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $('<div/>', {
                        "class": cssClass,
                        html: result.data
                    }).appendTo(input_el.parent());
                    $('img[data-src]').each(function(img){
                        $(this).attr('src', $(this).data('src'));
                        $(this).removeAttr('data-src');
                    });

                    if(sticky == 1){
                        var stickyOffset = $(".sticky").offset();
                        $('.sticky').affix({
                            offset: {
                                top: (stickyOffset.top - 115),
                                bottom: ($('.footer').outerHeight(true) + 50)
                            }
                        });
                    }
                }
            }
        );
    });
});
if($(".sticky").length > 0){
    var stickyOffset = $(".sticky").offset();
    $('.sticky').affix({
        offset: {
            top: (stickyOffset.top - 115),
            bottom: ($('.footer').outerHeight(true) + 50)
        }
    });
}